import { NodeBaseModel } from '../models';
import { NodeBaseDto } from '../types';

export default class NodeUtils {
    static copyNodeDtos(nodes: NodeBaseModel[]): NodeBaseDto[] {
        return NodeUtils.deepCloneNodeDtos(nodes.map(node => node.dto));
    }

    static deepCloneNodeDtos(nodes: NodeBaseDto[]): NodeBaseDto[] {
        return JSON.parse(JSON.stringify(nodes));
    }
}
